module.exports = __webpack_public_path__ + "static/media/inclusive-pause.99407022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inclusive-pause.svg
// module id = ./src/assets/images/inclusive-pause.svg
// module chunks = 0